<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     @updateValues="setupUpdateValues">
      <component :is="childHeaderComponent" :view="view" :auth-token="authToken" @updateValues="setupUpdateValues"
                 :formBancoTasaEfectivaAnual="formBancoTasaEfectivaAnual"
                 :cuentasBancarias="cuentasBancarias"
                 :arregloBancos="arregloBancos"
                 :tasaEA="tasaEA"
                 :listarCuentasBancariasPorMesYear="listarCuentasBancariasPorMesYear"
                 :listarTasasEA="listarTasasEA"
                 @customSaveData="(newCustomSaveData)=>updateValues(newCustomSaveData,this)"
                 :refreshData = "refreshData"
                 @updateBancoId="(newBancoId)=>updateValues(newBancoId, formBancoTasaEfectivaAnual)"></component>
    </HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedExtractoBancario" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-collection-data="customUpdateCollectionData"
                    @updateValues="setupUpdateValues">
      <template v-slot="{data}">
        <button @click="view = 'sublistar'; selectedExtractoBancario = data"
                class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none flex gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
          </svg>
          <span style="white-space: nowrap;">Ver movimientos</span>
        </button>
      </template>
    </TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else-if="view === 'actualizar' || view === 'crear'">
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedExtractoBancario"
                           :load-data="loadDataExtractoBancario" :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries" :custom-update-load-data="customUpdateLoadData"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :auth-token="authToken" :view="view"
                 :load-data="loadDataExtractoBancario"
                 :cuentasBancarias="cuentasBancarias"
                 :arregloBancos="arregloBancos"
                 :tasaEA="tasaEA"
                 :formBancoTasaEfectivaAnual="formBancoTasaEfectivaAnual"
                 :listarCuentasBancariasPorMesYear="listarCuentasBancariasPorMesYear"
                 :listarTasasEA="listarTasasEA"
                 :custom-update-value-data="customUpdateValueData"
                 @updateBancoId="(newBancoId)=>updateValues(newBancoId, formBancoTasaEfectivaAnual)"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
  <template v-else-if="view === 'sublistar'">
    <MovimientosBancarios :selected-extracto-bancario="selectedExtractoBancario"
                          @updateValues="setupUpdateValues"></MovimientosBancarios>
  </template>
  <template v-else-if="view === 'calcularExtracto'">
    <CalcularExtracto :vista="view"
                    :informacionCalculoMovimientos="informacionCalculoMovimientos" :listIngresos="listIngresos"
                    :selectedYear="+Object.keys(informacionCalculoMovimientos)[0]" :selectedMonth="+Object.keys(informacionCalculoMovimientos[Object.keys(informacionCalculoMovimientos)[0]])[0]"
                    :listEgresos="listEgresos" @updateValues="(newValues)=>updateValues(newValues, this)"></CalcularExtracto>
  </template>
</template>
<script>
import {reactive, ref, watch} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {copiaProfunda, fixDecimals, getCurrentMonth, filterCustomSearch, useAPIRest, generateTextError, verifyHttpCode, swal} from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import MovimientosBancarios from "@/components/rendimientos/components/MovimientosBancarios";
import ExtractosBancariosCrearActualizarComponent from "./components/ExtractosBancariosCrearActualizarComponent.vue";
import ExtractosBancariosChildHeaderComponent from "./components/ExtractosBancariosChildHeaderComponent";
import CalcularExtracto from "./components/CalcularExtracto";
import {listCollectionData, updateValues, useLayoutMain} from "@/layouts/main";

export default {
  name: 'ExtractosBancariosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    MovimientosBancarios,
    ExtractosBancariosCrearActualizarComponent,
    ExtractosBancariosChildHeaderComponent,
    CalcularExtracto
  },
  data: function () {
    return {
      Object: Object,
      title: 'Extractos bancarios',
      entity: {gender: 'm', value: 'extracto bancario'},
      childFormComponent: 'ExtractosBancariosCrearActualizarComponent',
      childHeaderComponent: 'ExtractosBancariosChildHeaderComponent',
      tableColumns: {
        'bancoTasaEfectivaAnual.cuentaBancaria.banco.nombre_banco': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del banco'
        },
        'bancoTasaEfectivaAnual.cuentaBancaria.cuenta_bancaria': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Cuenta bancaria'
        },
        'bancoTasaEfectivaAnual.cuentaBancaria.nombre_cuenta': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre cuenta bancaria'
        },
        'bancoTasaEfectivaAnual.tasa_efectiva_anual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tasa efectiva anual'
        },
        'year': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Año'
        },
        'mes': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Mes'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const informacionCalculoMovimientos = ref([]);
    const listIngresos = ref([]);
    const listEgresos = ref([]);
    const cuentasBancarias = ref([]);
    const arregloBancos = ref([]);
    const selectedExtractoBancario = ref({
      id: '',
      banco_tasa_efectiva_anual_id: '',
      year: '',
      mes: '',
      estado: ''
    });
    const loadDataExtractoBancario = ref({
      banco_tasa_efectiva_anual_id: '',
      year: '',
      mes: ''
    });
    const formBancoTasaEfectivaAnual = ref({
      banco_id: '',
    });
    const tasaEA = ref({
      id: '',
      created_at: '',
      cuenta_bancaria_id: '',
      tasa_efectiva_anual: '',
      fecha_inicial_vigencia: '',
      estado: ''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_EXTRACTOBANCARIO_CREATE,
      list: process.env.VUE_APP_NEST_EXTRACTOBANCARIO_FINDALL,
      update: process.env.VUE_APP_NEST_EXTRACTOBANCARIO_UPDATE,
      updateState: process.env.VUE_APP_NEST_EXTRACTOBANCARIO_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      if (['banco_tasa_efectiva_anual_id', 'cuenta_bancaria_id', 'year', 'mes'].includes(key)) return value !== '' ? Number(value) : value;
      return value;
    };
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedExtractoBancario.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedExtractoBancario.value = updatedSelectedData;
    }
    const customUpdateLoadData = () => {
      for (const key in loadDataExtractoBancario.value) {
        let value = loadDataExtractoBancario.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['bancoTasaEfectivaAnual']['tasa_efectiva_anual'] = fixDecimals(copyData['bancoTasaEfectivaAnual']['tasa_efectiva_anual']) + '%';
        copyData['mes'] = getCurrentMonth(copyData['mes'])
      }
      return copyCollectionData;
    };
    const refreshData = async ()=> {
      return listCollectionData(listApi['list'], setupUpdateValues, authToken.value, undefined, undefined, undefined, undefined, undefined, 'table.estado = 1', undefined, undefined)
    }
    watch(() => view.value, async (newView) => {
      if(newView === "listar") await listCollectionData(listApi['list'], setupUpdateValues, authToken.value, undefined, undefined, undefined, undefined, undefined, 'table.estado = 1', undefined, undefined)
    });
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedExtractoBancario, loadDataExtractoBancario, listApi);

    const listarCuentasBancariasPorMesYear = async (tokenUpdated, page = 1, orderBy = 'created_at', order = 'ASC', criterion = '', search = '', where = '', isPaginate = true) => {
      formBancoTasaEfectivaAnual.value.banco_id = '';
      search = filterCustomSearch(criterion, search);
      await useAPIRest(process.env.VUE_APP_NEST_BANCOTEA_FINDALL, 'GET', tokenUpdated, undefined, {
        page,
        orderBy,
        order,
        criterion,
        search,
        where,
        isPaginate
      }).then(async resJSON => {
        const {statusCode} = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          const listCuentasBancarias = [];
          for (const tasa of resJSON) {
            listCuentasBancarias.push(tasa.cuentaBancaria);
          }
          cuentasBancarias.value = listCuentasBancarias;

          let hash = {};
          arregloBancos.value = cuentasBancarias.value.filter(o => hash[o.banco_id] ? false : hash[o.banco_id] = true)

        } else await swal.fire(textoError, '', 'error');
      });
    };
    const listarTasasEA = async (tokenUpdated, page = 1, orderBy = 'created_at', order = 'ASC', criterion = '', search = '', where = '', isPaginate = true) => {
      search = filterCustomSearch(criterion, search);
      await useAPIRest(process.env.VUE_APP_NEST_BANCOTEA_FINDALL, 'GET', tokenUpdated, undefined, {
        page,
        orderBy,
        order,
        criterion,
        search,
        where,
        isPaginate
      }).then(async resJSON => {
        const {statusCode} = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) tasaEA.value = resJSON[0];
        else await swal.fire(textoError, '', 'error');
      });
    };

    return {
      view,
      collectionData,
      authToken,
      selectedExtractoBancario,
      loadDataExtractoBancario,
      formBancoTasaEfectivaAnual,
      cuentasBancarias,
      arregloBancos,
      tasaEA,
      informacionCalculoMovimientos,
      listIngresos,
      listEgresos,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      listarCuentasBancariasPorMesYear,
      listarTasasEA,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData,
      updateValues,
      refreshData
    }
  },
}
</script>